<template>
	<div class="view-wrapper">
		<div class="row">
			<div class="col">
				<b-card header-tag="h5" header="Current Level" class="mb-3">
					<planning-current-level @addLevel="addLevel"></planning-current-level>
				</b-card>
			</div>
		</div>
		
		<div class="row">
			<div class="col">
				<b-card header-tag="h5" header="Levels" class="mb-3">
					<planned-level v-for="(levelData, level) in levels" :key="'planned-level-'+level" :level="level" :data="levelData" @discard="removeLevel"></planned-level>
					<div class="text-center">
						<b-button-group>
							<b-button variant="secondary" @click="addLevel" v-if="Object.keys(levels).length < 20">Add Level</b-button>
						</b-button-group>
					</div>
				</b-card>
			</div>
		</div>
	</div>
</template>

<script>
import PlanningCurrentLevel from '@/components/planning/CurrentLevel.vue'
import PlannedLevel from '@/components/planning/PlannedLevel.vue'

export default {
	components: {
		PlanningCurrentLevel,
		PlannedLevel,
	},
	computed: {
		levels: function(){
			return this.$store.state.Character.Levels
		},
		highestLevel: function() {
			return Object.keys(this.levels).length
		}
	},
	methods: {
		addLevel: function(){
			if(this.highestLevel < 20){
				var newLevel
				var newLevelData = Object.assign({}, this.levels[this.highestLevel])
				newLevelData.Abilities = []

				for(var skill in newLevelData.Skills){
					newLevelData.Skills[skill] = 0
				}
				
				if(newLevel % 2 == 1){
					newLevelData.Feats[0] = {Name: "", Description: ""}
				}
				if(newLevel % 6 == 0){
					newLevelData.Theme = {Name: "", Description: ""}
				}
				if(newLevel % 5 == 0){
					newLevelData.AbilityIncreases = {Strength:0,Dexterity:0,Constitution:0,Intelligence:0,Wisdom:0,Charisma:0}
				}
				if(this.levels[this.highestLevel].Drone||false){
					newLevelData.Drone = this.levels[this.highestLevel].Drone
					newLevelData.Drone.Level = parseInt(this.levels[this.highestLevel].Drone.Level)
				}
				if(this.levels[this.highestLevel].Companion||false){
					newLevelData.Companion = this.levels[this.highestLevel].Companion
					newLevelData.Companion.Level = parseInt(this.levels[this.highestLevel].Companion.Level)
				}
				if(this.levels[this.highestLevel].Pools||false){
					newLevelData.Pools = this.levels[this.highestLevel].Pools
					newLevelData.Pools.Level = parseInt(this.levels[this.highestLevel].Pools.Level)
				}
				this.$set( this.levels, this.highestLevel+1, newLevelData)
			}
		},
		removeLevel: function(level){
			this.$delete( this.levels, level)
		}
	}
}
</script>

<style scoped>

</style>